import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMaincategory, useNews, useMain } from "../../actions/homeActions";
export default () => {
  const [allcategories, setAllcategories] = useState(true);
  const [seteledcategories, setSeteledcategories] = useState(false);
  const [jobHasMorePages, setNewsHasMorePages] = useState(false);
  const [additionalJobs, setAdditionalNews] = useState([]);
  const [allNewsCurrentPage, setAllNewsCurrentPage] = useState(1);
  const navigate = useNavigate();
  const [categoriesTtypesNewsId, setCategoriesTtypesNewsId] = useState(null);
  const { data: CategoriesTypesNews, isError, error } = useMaincategory("news");
  const { data: newsData, isLoading: newsDataisLoading } =
    useNews(allNewsCurrentPage);
  const {
    data: newsList,
    isLoading,
    isError: newsListisError,
    error: newsListError,
  } = useMain(categoriesTtypesNewsId);
  useEffect(() => {
    if (newsData) {
      setNewsHasMorePages(newsData?.has_more_pages);
      setAdditionalNews((prevNews) => {
        const newNews = newsData?.news || [];
        const uniqueJobs = [...prevNews, ...newNews].reduce((acc, news) => {
          if (!acc.some((j) => j.id === news.id)) {
            acc.push(news);
          }
          return acc;
        }, []);
        return uniqueJobs;
      });
    }
  }, [newsData]);
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading categories Ttypes News: {error.message}
        </p>
      </div>
    );
  }
  if (newsListisError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading news List: {newsListError.message}
        </p>
      </div>
    );
  }
  const handleButtonClick = (id) => {
    setAllcategories(false);
    setSeteledcategories(true);
    setCategoriesTtypesNewsId(id);
  };

  const handleNews = (id) => {
    navigate(`/news-details/${id}`);
  };
  return {
    setAllcategories,
    setSeteledcategories,
    CategoriesTypesNews,
    handleButtonClick,
    allcategories,
    categoriesTtypesNewsId,
    newsData,
    additionalJobs,
    handleNews,
    newsDataisLoading,
    jobHasMorePages,
    setAllNewsCurrentPage,
    seteledcategories,
    isLoading,
    newsList,
  };
};
